interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'FAQPage' | 'Article';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  let schema: Record<string, unknown> = {};

  switch (type) {
    case 'Organization':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '嫩草影院',
        url: 'https://www.nencaoyingyuan.com',
        description: '嫩草影院是您最佳的在线影视观看平台，提供海量高清电影、电视剧、动漫、综艺等内容，支持免费流畅播放，无需注册即可享受优质观影体验。',
        sameAs: [
          'https://weibo.com/nencaoyingyuan',
          'https://weixin.qq.com/nencaoyingyuan',
        ],
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'service@nencaoyingyuan.com',
          availableLanguage: ['Chinese'],
        },
        ...data,
      };
      break;
    case 'WebSite':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '嫩草影院',
        url: 'https://www.nencaoyingyuan.com',
        description: '嫩草影院 - 高清影视在线观看平台，免费观看海量电影、电视剧、动漫、综艺',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.nencaoyingyuan.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
        ...data,
      };
      break;
    case 'WebPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '嫩草影院',
        url: 'https://www.nencaoyingyuan.com',
        description: '嫩草影院 - 高清影视在线观看平台',
        inLanguage: 'zh-CN',
        isPartOf: {
          '@type': 'WebSite',
          name: '嫩草影院',
          url: 'https://www.nencaoyingyuan.com',
        },
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (data.mainEntity as unknown[]) || [],
        ...data,
      };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: '',
        author: {
          '@type': 'Organization',
          name: '嫩草影院',
        },
        publisher: {
          '@type': 'Organization',
          name: '嫩草影院',
        },
        ...data,
      };
      break;
  }

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
}